import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { Router } from '@angular/router';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { AppDataService } from 'src/app/services/app-data.service';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { FILTER_QUESTION_CODES, FORM_ACTIONS, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { UserGridFilterRequest } from 'src/app/interfaces/user-grid-filter-request.interface';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value;
  }

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.userList,
      () => API_ENDPOINTS.dashboard.getUsers,
      false
    );
  }

  ngOnInit(): void {}

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.userListForm.userListFilter: {
        const userFilterRequest = this.getUserFilterRequest();
        this.loadGridData(userFilterRequest);
        break;
      }
    }
  }

  dialogButtonClicked(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }

  actionButtonClicked(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.userListForm.userPlaceholder: {
        switch (event.event.type) {
          case FORM_ACTIONS.userListForm.new: {
            this.router.navigate(['/', ROUTE_CONSTANTS.user.prefix]);
            break;
          }
          case FORM_ACTIONS.userListForm.view:
          case FORM_ACTIONS.userListForm.edit: {
            this.router.navigate([
              '/',
              ROUTE_CONSTANTS.user.prefix,
              event.event.data.id,
            ]);
            break;
          }
        }
        break;
      }
    }
  }

  private getUserFilterRequest(): UserGridFilterRequest {
    const userFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.userListForm.users,
      PAGE_NUMBERS.userListForm.users,
      SECTION_CODES.userListForm.user,
      QUESTION_CODES.userListForm.userListFilter
    );
    const userFilterRequest: UserGridFilterRequest = {
      name:
        userFilterModel?.[
        FILTER_QUESTION_CODES.userListForm.nameFilter
        ],
      email:
        userFilterModel?.[
        FILTER_QUESTION_CODES.userListForm.emailFilter
        ],
      phoneNumber:
        userFilterModel?.[
        FILTER_QUESTION_CODES.userListForm.phoneFilter
        ],
      organisationName:
        userFilterModel?.[
        FILTER_QUESTION_CODES.userListForm.organisationFilter
        ],
      userType:
        userFilterModel?.[
        FILTER_QUESTION_CODES.userListForm.userTypeFilter
        ],
    };
    return userFilterRequest;
  }
}
